import { PageInterface } from "../../types";

export const getPageByName = (
    allPages: PageInterface[],
    pageName?: string,
    pageFlow?: string,
) => {
    return allPages.find((page) => {
        if (pageFlow) {
            return page.name === pageName && pageFlow === page.flow;
        }

        return page.name === pageName;
    });
};

export const getPageByPath = (
    allPages: PageInterface[],
    pagePath: string,
    pageFlow?: string,
) => {
    return allPages.find((page) => {
        // const concatinatedPagePath = process.env.GATSBY_PATH_PREFIX + pagePath;
        let sanitizedPagePath = pagePath;
        if (process.env.GATSBY_PATH_PREFIX !== undefined) {
            sanitizedPagePath = pagePath.replace(
                process.env.GATSBY_PATH_PREFIX,
                "",
            );
        }
        // For a certain reason a / is added on refresh when the storage is empty
        const pathMatch =
            page.url === sanitizedPagePath ||
            page.url + "/" === sanitizedPagePath;

        if (pageFlow) {
            return pathMatch && pageFlow === page.flow;
        }

        return pathMatch;
        2;
    });
};
